import counters from './counters';
import lazyloadimages from './lazyloadimages';
import initNavbarburger from './navbar-burger';
import initScrollToTopButton from './scroll';

// Cross-browser implementation of element.addEventListener()
function registerListener(evnt, elem, func) {
    if (elem.addEventListener)  // W3C DOM
    elem.addEventListener(evnt,func,false);
    else if (elem.attachEvent) { // IE DOM
        var r = elem.attachEvent("on"+evnt, func);
        return r;
    }
    // else window.alert('I\'m sorry Dave, I\'m afraid I can\'t do that.');
}

registerListener("load", window, lazyloadimages);

// registerListener('load', window, lazyloadimages.setLazy);
// registerListener('load', window, lazyloadimages.lazyLoad);
// registerListener('scroll', window, lazyloadimages.lazyLoad);
// registerListener('resize', window, lazyloadimages.lazyLoad);

if(window.location.pathname == "/"){
    registerListener("load", window, counters);    
}

document.addEventListener('DOMContentLoaded', initNavbarburger);

initScrollToTopButton();
